var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 7.5 15.5 7.5 16 8.5C16 8.5 17.5882 6 19 5.5",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7C22 9.76142 19.7614 12 17 12C14.2386 12 12 9.76142 12 7C12 4.23858 14.2386 2 17 2C19.7614 2 22 4.23858 22 7Z",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4706 2.75C10.8848 2.75 11.2206 2.41421 11.2206 2C11.2206 1.58579 10.8848 1.25 10.4706 1.25V2.75ZM20.7499 14.4189C20.7501 14.0047 20.4145 13.6687 20.0003 13.6685C19.5861 13.6683 19.2501 14.0039 19.2499 14.4181L20.7499 14.4189ZM11.5294 21.25H10.4706V22.75H11.5294V21.25ZM2.75 14V10H1.25V14H2.75ZM2.75 10C2.75 8.09197 2.75178 6.74077 2.89758 5.71661C3.03964 4.71864 3.30515 4.14213 3.75546 3.71683L2.72552 2.62631C1.93534 3.37259 1.5806 4.32468 1.41255 5.50521C1.24822 6.65957 1.25 8.13679 1.25 10H2.75ZM10.4706 1.25C8.49411 1.25 6.94044 1.24858 5.72885 1.40242C4.49987 1.55847 3.50965 1.88575 2.72552 2.62631L3.75546 3.71683C4.21182 3.28582 4.84011 3.02731 5.91779 2.89047C7.01286 2.75142 8.454 2.75 10.4706 2.75V1.25ZM10.4706 21.25C8.454 21.25 7.01286 21.2486 5.91779 21.1095C4.84011 20.9727 4.21182 20.7142 3.75546 20.2832L2.72552 21.3737C3.50965 22.1142 4.49987 22.4415 5.72884 22.5976C6.94043 22.7514 8.4941 22.75 10.4706 22.75V21.25ZM1.25 14C1.25 15.8632 1.24822 17.3404 1.41255 18.4948C1.5806 19.6753 1.93534 20.6274 2.72552 21.3737L3.75546 20.2832C3.30515 19.8579 3.03964 19.2814 2.89758 18.2834C2.75178 17.2592 2.75 15.908 2.75 14H1.25ZM11.5294 22.75C13.5059 22.75 15.0596 22.7514 16.2712 22.5976C17.5001 22.4415 18.4904 22.1143 19.2745 21.3737L18.2445 20.2832C17.7882 20.7142 17.1599 20.9727 16.0822 21.1095C14.9871 21.2486 13.546 21.25 11.5294 21.25V22.75ZM19.2499 14.4181C19.2491 16.1827 19.2356 17.4394 19.0858 18.3947C18.9401 19.3239 18.6785 19.8734 18.2445 20.2832L19.2745 21.3737C20.0343 20.6561 20.392 19.7476 20.5677 18.6271C20.7393 17.5328 20.7491 16.1482 20.7499 14.4189L19.2499 14.4181Z",
    fill: "#676767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H11",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H15",
    stroke: "#676767",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update-icon.e2f1228b95492054bb01a22318128b1c.svg";
export { ForwardRef as ReactComponent };